import { createStore } from './createStore';

const initialState = {
  isOpen: false,
  sessionId: null,
  messages: [],       // Array<{ id, sender, content, created_at }>
  status: 'closed',   // 'open' | 'closed'
  isLoading: false,
  isSending: false,
  error: null,
};

const useSupportChatStore = createStore('SupportChatStore', (set) => ({
  ...initialState,

  openChat: () => set({ isOpen: true }),
  closeChat: () => set({ isOpen: false }),

  setSession: (session) => set({
    sessionId: session.session_id,
    status: session.status,
    messages: session.messages || [],
  }),

  appendMessage: (msg) => set((state) => ({
    messages: [...state.messages, msg],
  })),

  setLoading: (isLoading) => set({ isLoading }),
  setSending: (isSending) => set({ isSending }),
  setError: (error) => set({ error }),

  resetChat: () => set({ ...initialState }),
}));

export default useSupportChatStore;
